import moment from 'moment-timezone';

import {type DynamicTrackingEvents} from './events';

type ValueOf<T> = T[keyof T];
export type DynamicTrackingEvent = ReturnType<ValueOf<typeof DynamicTrackingEvents>>;

export const isValidTrackingEvent = (candidate: unknown): candidate is TrackingEvent => {
    if (
        typeof candidate === 'object' &&
        candidate &&
        'name' in candidate &&
        'sendTo' in candidate &&
        'expirationDate' in candidate &&
        'isActive' in candidate &&
        typeof candidate.isActive === 'boolean' &&
        typeof candidate.name === 'string' &&
        typeof candidate.expirationDate === 'string' &&
        Array.isArray(candidate.sendTo)
    ) {
        const {expirationDate, isActive} = candidate;

        // If it's not active, we'll ignore it as well.
        if (!isActive) {
            return false;
        }

        // Indefinite expiration date means we should always send it.
        if (expirationDate === 'none') {
            return true;
        }

        const momentExpirationDate = moment(expirationDate);

        // If the expiration date is invalid, we'll ignore it.
        if (!momentExpirationDate.isValid()) {
            return false;
        }

        // If the expiration date has passed, we'll ignore it.
        if (moment().isAfter(momentExpirationDate, 'day')) {
            return false;
        }

        return true;
    }

    return false;
};

type Month = '01' | '02' | '03' | '04' | '05' | '06' | '07' | '08' | '09' | '10' | '11' | '12';

type YYYYMMDD = `20${number}${number}-${Month}-${number}${number}`;

export type TrackingEvent = {
    name: string;
    sendTo: NonEmptyArray<'Mixpanel' | 'Bucket'>;
    expirationDate: 'none' | YYYYMMDD;
    isActive: boolean;
};
